// AIMS FIX 27/08/26 - assets/rfq-drawer.js
//
// 1. The Request Quote button hardcoded qty: 1 and ignored the quantity selector
//    on the page. It now reads the live quantity at click time.
// 2. Repeat clicks added 1 instead of the chosen quantity (add 3 twice gave 2).
// 3. data-sku on the button is correct on page load but is NOT refreshed by
//    product-info.js when the shopper switches variant without a reload, so a
//    quote could carry the previously selected SKU. SKU, variant id and option
//    labels are now read from the live DOM at click time, with the data-
//    attributes kept as a fallback.
// 4. The saved URL now carries ?variant= so the sales desk lands on the exact SKU.
// 5. Values are HTML-escaped before being written into the drawer.

document.addEventListener("DOMContentLoaded", function () {
  let quoteCart = JSON.parse(localStorage.getItem("quoteCart")) || [];

  function updateQuoteCount() {
    let count = quoteCart.length;
    let drawerCount = document.getElementById("quote-count");
    let headerCount = document.getElementById("header-quote-count");
    if (drawerCount) drawerCount.innerText = count;
    if (headerCount) headerCount.innerText = count;
  }

  // Scope lookups to the product block the button lives in, so the main product
  // and the collection page quick view never read each other's fields.
  function getScope(el) {
    return el.closest("product-info") || el.closest(".product-form")?.parentElement || document;
  }

  function readQuantity(btn) {
    let input = getScope(btn).querySelector('input[name="quantity"]');
    let qty = parseInt(input && input.value, 10);
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function readSku(btn) {
    let el = getScope(btn).querySelector('[id^="Sku-"] span:last-child, .product__sku span:last-child');
    let live = el ? el.textContent.trim() : "";
    if (live && live.toUpperCase() !== "SKU:") return live;
    return btn.dataset.sku || "";
  }

  function readVariantId(btn) {
    let input = getScope(btn).querySelector('input[name="id"]');
    return input && input.value ? input.value : "";
  }

  function readVariantLabel(btn) {
    let scope = getScope(btn);
    let parts = [];
    scope.querySelectorAll(".product-form__input select").forEach(function (s) {
      if (s.selectedOptions[0]) parts.push(s.selectedOptions[0].value);
    });
    scope.querySelectorAll('.product-form__input input[type="radio"]:checked').forEach(function (r) {
      parts.push(r.value);
    });
    return parts.join(" / ");
  }

  document.addEventListener("click", function (e) {
    let btn = e.target.closest ? e.target.closest(".add-to-quote") : null;
    if (!btn) return;

    let qty = readQuantity(btn);
    let variantId = readVariantId(btn);
    let url = btn.dataset.url || "";
    if (variantId && url && url.indexOf("?") === -1) url = url + "?variant=" + variantId;

    let item = {
      title: btn.dataset.title,
      sku: readSku(btn),
      variantId: variantId,
      variant: readVariantLabel(btn),
      image: btn.dataset.image,
      url: url,
      qty: qty,
    };

    let existing = quoteCart.find(function (p) {
      return item.variantId && p.variantId ? p.variantId === item.variantId : p.sku === item.sku;
    });

    if (existing) {
      existing.qty = (parseInt(existing.qty, 10) || 0) + qty;
    } else {
      quoteCart.push(item);
    }

    localStorage.setItem("quoteCart", JSON.stringify(quoteCart));
    updateQuoteCount();
    openQuoteDrawer();
  });

  function openQuoteDrawer() {
    document.getElementById("quote-drawer").classList.add("open");
    renderQuote();
  }

  let openBtn = document.getElementById("quote-open");
  if (openBtn) openBtn.onclick = openQuoteDrawer;

  let closeBtn = document.getElementById("quote-close");
  if (closeBtn) {
    closeBtn.onclick = function () {
      document.getElementById("quote-drawer").classList.remove("open");
    };
  }

  function escapeHtml(str) {
    return String(str == null ? "" : str).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function renderQuote() {
    let container = document.getElementById("quote-items");
    let items = JSON.parse(localStorage.getItem("quoteCart")) || [];
    let html = "";
    items.forEach(function (item, index) {
      html += `
        <div class="quote-item">
          <img src="${escapeHtml(item.image)}">
          <div>
            <div class="quote-item-title">${escapeHtml(item.title)}</div>
            ${item.variant ? `<div class="quote-item-variant">${escapeHtml(item.variant)}</div>` : ""}
            <div>SKU: ${escapeHtml(item.sku)}</div>
            <input type="number" value="${parseInt(item.qty, 10) || 1}" min="1" onchange="updateQty(${index}, this.value)">
            <button onclick="removeQuote(${index})">Remove</button>
          </div>
        </div>`;
    });
    if (container) container.innerHTML = html;
  }

  window.removeQuote = function (index) {
    quoteCart.splice(index, 1);
    localStorage.setItem("quoteCart", JSON.stringify(quoteCart));
    updateQuoteCount();
    renderQuote();
  };

  window.updateQty = function (index, val) {
    let qty = parseInt(val, 10);
    if (!Number.isFinite(qty) || qty < 1) qty = 1;
    quoteCart[index].qty = qty;
    localStorage.setItem("quoteCart", JSON.stringify(quoteCart));
  };

  let clearBtn = document.getElementById("clear-quote");
  if (clearBtn) {
    clearBtn.onclick = function () {
      quoteCart = [];
      localStorage.removeItem("quoteCart");
      renderQuote();
      updateQuoteCount();
    };
  }

  updateQuoteCount();
});